import React from "react";
import { Grid, Switch } from "@mui/material";

const Toggle = (props: any) => {
	return (
		<Grid item xs={props.Size} className={props.className}>
			{((props.Position ?? "start") === "start" && props.Label)}
			<Switch onChange={props.OnChange} defaultChecked={props.Checked} className={props.Position === undefined ? "right" : ""} disabled={props.Disabled} />
			{((props.Position ?? "start") === "end" && props.Label)}
		</Grid>
    );
};

export default Toggle;